export default "__VITE_PUBLIC_ASSET__05fa508f__"